import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import NavigationRowExpandImg from './styled/NavigationRowExpandImg';

import NavigationRow from './NavigationRow';

const NavigationLevel = ({ values, s3BasePath, handleLevel, handleBack, children, level }) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    {level !== 0 && (
      <>
        <NavigationRow text={values.name} handleClick={() => handleBack(false)} backRow>
          <NavigationRowExpandImg src={`${s3BasePath}mkt/icon/minus_white.png`} />
        </NavigationRow>
        <NavigationRow
          capitalize
          text={`all ${values.name}`}
          handleClick={() => handleLevel(values, { allCategoryClick: true })}
        />
      </>
    )}
    {values.children.map((curr, index) => (
      <Fragment key={curr.name}>
        <NavigationRow capitalize={level !== 0} text={curr.name} handleClick={() => handleLevel(curr)}>
          {curr.children && curr.children.length > 0 && (
            <NavigationRowExpandImg src={`${s3BasePath}mkt/icon/plus_black.png`} />
          )}
        </NavigationRow>
      </Fragment>
    ))}
    {children}
  </div>
);

NavigationLevel.propTypes = {
  values: PropTypes.shape({
    id: PropTypes.string,
    sub: PropTypes.array,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  s3BasePath: PropTypes.string,
  handleLevel: PropTypes.func,
  handleBack: PropTypes.func,
  level: PropTypes.number,
};

export default NavigationLevel;
